module.exports = __webpack_public_path__ + "img/logo.spedido.nobg.4389a6a3.png";